import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=370608da&scoped=true&"
import script from "./orderInfo.js?vue&type=script&lang=js&"
export * from "./orderInfo.js?vue&type=script&lang=js&"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=370608da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370608da",
  null
  
)

export default component.exports